import { __assign, __awaiter, __extends, __generator } from "tslib";
import cn from 'classnames';
import { mmUid } from 'mm-ts-utils';
import ms from 'ms';
import React from 'react';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import * as Scroll from 'react-scroll';
import { ARBITRARY_ID_LAST_SENT_MESSAGE, CUSTOM_MESSAGE_NEXT_INPUT_VALUE_FORCE_NONE, CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES, CUSTOM_MESSAGE_TYPE_MARKER, DOMAIN_TYPE_ARBITRARY, DUMMY_AUDIO, IS_DEVELOPMENT, NOTIFICATION_ID__THREAD_CHANGE, WIDGET_ID_PLEASE_WAIT, } from '../../../../consts';
import { ChatMessageType } from '../../../../_library/domain-base/BaseChatMessage';
import { wsJoinRoom, wsLeaveRoom } from '../../../../_library/utils/app-ws-room-utils';
import { domainAction, domainSelector } from '../../../domain/domain-redux';
import { dispatchOppositeParty } from '../../../domain/opposite-party';
import { dispatchUiState } from '../../../domain/ui-state';
import { identitySelector } from '../../../identity/identity-redux';
import { config } from '../../../_core/config';
import { getClientConfig } from '../../../_core/utils/app-storage';
import { createDebugLogger } from '../../../_core/utils/app-utils';
import { I18nMsgNs } from '../../../_core/utils/i18n-helpers';
import { _detectOppositeParty } from '../../actions/_detect-opposite-party';
import { chatAction } from '../../chat-redux';
import { ChatMessage } from '../../ChatMessage';
import ChatInput from '../ChatInput/ChatInput';
import { Messages } from '../Messages/Messages';
import { TypingUsers } from '../TypingUsers/TypingUsers';
import './ChatThread.scss';
import ChatThreadDebugInfo from './ChatThreadDebugInfo';
import { remoteLog } from '../../../../_library/utils/remote-log';
import { isNetworkErrorMessage } from '../../../_core/utils/network-utils';
var Msg = I18nMsgNs('ChatThread');
var parseTimeoutValue = function (value) {
    if (!value)
        return null;
    return typeof value === 'number' ? value : ms(value);
};
var debug = createDebugLogger('ChatThread');
var ChatThreadClass = /** @class */ (function (_super) {
    __extends(ChatThreadClass, _super);
    function ChatThreadClass(props) {
        var _this = _super.call(this, props) || this;
        _this.$scrollContainer = React.createRef();
        _this.scrollToBottom = function () {
            setTimeout(function () {
                Scroll.animateScroll.scrollToBottom({
                    duration: 200,
                    delay: 0,
                    smooth: true,
                    containerId: 'scrollContainer',
                    isDynamic: true,
                    ignoreCancelEvents: true,
                });
            }, 100);
        };
        _this.submitMessage = function (value, type, meta) {
            if (meta === void 0) { meta = {}; }
            return ChatThreadClass.submitMessage(_this.props, value, type, meta);
        };
        if (!_this.props.threadId) {
            throw new Error('Missing expected threadId prop');
        }
        _this.handleOnAction = _this.handleOnAction.bind(_this);
        _this.handleOnActive = _this.handleOnActive.bind(_this);
        _this.handleOnIdle = _this.handleOnIdle.bind(_this);
        _this.msgSound = new Audio();
        return _this;
    }
    ChatThreadClass.prototype.componentDidMount = function () {
        var _this = this;
        var _a = getClientConfig(), TIMEOUT_NOTIFICATION_TIME = _a.TIMEOUT_NOTIFICATION_TIME, TIMEOUT_TIME = _a.TIMEOUT_TIME, MSG_SOUND_SRC = _a.MSG_SOUND_SRC, IS_MSG_SOUND_ENABLED = _a.IS_MSG_SOUND_ENABLED;
        dispatchUiState(this.props.dispatch, {
            chat_input_hidden: false,
            chat_input_disabled: false,
        });
        this.idleTimer = null;
        this.notificationTimeout = parseTimeoutValue(TIMEOUT_NOTIFICATION_TIME);
        this.timeout = parseTimeoutValue(TIMEOUT_TIME);
        this.msgSound.src =
            MSG_SOUND_SRC ||
                'https://notificationsounds.com/storage/sounds/file-sounds-1148-juntos.mp3';
        this.useSound = Boolean(IS_MSG_SOUND_ENABLED) || false;
        document.body.addEventListener('click', function () {
            return _this.unlockAudio(_this.msgSound.src);
        });
        document.body.addEventListener('touchstart', function () {
            return _this.unlockAudio(_this.msgSound.src);
        });
    };
    ChatThreadClass.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var prevLength = this.getScrollRelevantMessagesLength(prevProps.messages);
        var length = this.getScrollRelevantMessagesLength(this.props.messages);
        if (snapshot && typeof snapshot.scrollTop === 'number') {
            debug("Setting scrollTop from snapshot: ".concat(snapshot.scrollTop));
            this.$scrollContainer.current.scrollTop = snapshot.scrollTop;
        }
        if (prevLength < length) {
            try {
                if (this.props.lastMessage.authorType !== ChatMessage.AUTHOR_TYPE_USER &&
                    this.useSound) {
                    var pPromise = this.msgSound.play();
                    if (pPromise !== undefined) {
                        pPromise
                            .then(function (_) {
                            // sound plays
                        })
                            .catch(function (error) {
                            // error playing sound
                        });
                    }
                }
            }
            catch (error) {
                console.error(error);
            }
            var isUserMessage = this.props.lastMessage.authorType === ChatMessage.AUTHOR_TYPE_USER;
            if (isUserMessage || (snapshot && snapshot.isAtBottom)) {
                this.scrollToBottom();
            }
        }
        var oppositeParty = _detectOppositeParty(this.props.messages);
        if (oppositeParty === 'agent' && this.props.isAgent === false) {
            dispatchOppositeParty(this.props.dispatch, true);
        }
    };
    ChatThreadClass.prototype.unlockAudio = function (originalSrc) {
        var _this = this;
        this.msgSound.src = DUMMY_AUDIO;
        var pPromise = this.msgSound.play();
        if (pPromise !== undefined) {
            pPromise
                .then(function (_) {
                _this.msgSound.pause();
                _this.msgSound.currentTime = 0;
                _this.msgSound.src = originalSrc;
            })
                .catch(function (error) {
                console.error(error);
            });
        }
        document.body.removeEventListener('click', this.unlockAudio);
        document.body.removeEventListener('touchstart', this.unlockAudio);
    };
    ChatThreadClass.prototype.handleOnAction = function (event) {
    };
    ChatThreadClass.prototype.handleOnActive = function (event) {
        clearTimeout(this.timeoutId);
    };
    ChatThreadClass.prototype.handleOnIdle = function () {
        var _this = this;
        var _a = getClientConfig(), TIMEOUT_NOTIFICATION_MSG = _a.TIMEOUT_NOTIFICATION_MSG, TIMEOUT_MSG = _a.TIMEOUT_MSG;
        this.submitMessage('Notification', ChatMessageType.NOTIFICATION, {
            message: TIMEOUT_NOTIFICATION_MSG,
            hideInput: false,
        });
        this.timeoutId = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.idleTimer.pause();
                        return [4 /*yield*/, this.submitMessage('Notification', ChatMessageType.END, {
                                message: TIMEOUT_MSG,
                                hideInput: true,
                            })];
                    case 1:
                        _b.sent();
                        this.submitMessage(JSON.stringify({
                            type: CUSTOM_MESSAGE_TYPE_MARKER,
                            room: CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES,
                            payload: (_a = {},
                                _a[CUSTOM_MESSAGE_NEXT_INPUT_VALUE_FORCE_NONE] = true,
                                _a.named_entities = {
                                    RPT_Business_Subresult: 'Customer did not react',
                                },
                                _a),
                        }), ChatMessageType.HIDDEN);
                        return [2 /*return*/];
                }
            });
        }); }, this.timeout);
    };
    ChatThreadClass.prototype.getSnapshotBeforeUpdate = function (prevProps, prevState) {
        var prevLength = this.getScrollRelevantMessagesLength(prevProps.messages);
        var length = this.getScrollRelevantMessagesLength(this.props.messages);
        if (prevLength < length) {
            var node = this.$scrollContainer.current;
            var scrollTop = node.scrollTop;
            var isAtBottom = node.scrollHeight - scrollTop - node.clientHeight < 50;
            debug("Saving scrollTop snapshot: ".concat(scrollTop, ", isAtBottom: ").concat(isAtBottom));
            return { scrollTop: scrollTop, isAtBottom: isAtBottom };
        }
        return null;
    };
    /**
     * Calculates the number of messages relevant for scrolling (excludes typing indicators)
     * @param messages
     * @private
     */
    ChatThreadClass.prototype.getScrollRelevantMessagesLength = function (messages) {
        var src = messages || [];
        return src.reduce(function (memo, message) {
            return (message === null || message === void 0 ? void 0 : message.type) === ChatMessageType.TRANSIENT_IS_TYPING
                ? memo
                : memo + 1;
        }, 0);
    };
    ChatThreadClass.prototype.componentWillUnmount = function () {
        var threadId = this.props.threadId;
        threadId && wsLeaveRoom(threadId);
    };
    ChatThreadClass.prototype.render = function () {
        var _this = this;
        var _a = this.props, identity = _a.identity, threadId = _a.threadId, messages = _a.messages, threadUpdated = _a.threadUpdated;
        var B = config.css.B('-chat-thread');
        threadId && wsJoinRoom(threadId);
        return (React.createElement("div", { className: cn(B) },
            this.timeout && (React.createElement(IdleTimer, { ref: function (ref) {
                    _this.idleTimer = ref;
                }, timeout: this.notificationTimeout, onActive: this.handleOnActive, onIdle: this.handleOnIdle, onAction: this.handleOnAction, debounce: 250 })),
            React.createElement(ChatThreadDebugInfo, { threadId: threadId }),
            React.createElement("div", { className: cn("".concat(B, "__messages")), id: "scrollContainer", ref: this.$scrollContainer },
                React.createElement(Messages, { identity: identity, messages: messages, threadLastUpdated: threadUpdated, submitMessage: this.submitMessage, scrollToBottom: this.scrollToBottom }),
                React.createElement(TypingUsers, { parentContainer: this.$scrollContainer, threadId: threadId, threadLastUpdated: threadUpdated, scrollToBottom: this.scrollToBottom })),
            this.props.chatInputHidden !== true && (React.createElement("div", { className: cn("".concat(B, "__input")) },
                React.createElement(ChatInput, { threadId: threadId, submitMessage: this.submitMessage, inputPlaceholder: this.props.inputPlaceholder })))));
    };
    ChatThreadClass.submitMessage = function (_a, value, type, meta) {
        var _b, _c;
        var dispatch = _a.dispatch, identity = _a.identity, threadId = _a.threadId;
        if (meta === void 0) { meta = {}; }
        try {
            if (value === 'TEST_THROW_ERROR') {
                throw new Error('TEST_THROW_ERROR: ' + new Date().toISOString());
            }
            var msg = new ChatMessage({
                id: mmUid(),
                thread_id: threadId,
                user_id: (identity || {}).id,
                body: "".concat(value).trim(),
                type: type || undefined,
                meta: meta || {},
            });
            // track last user sent message in a sane way
            dispatch(domainAction.mergeModelsPayload((_b = {},
                _b[DOMAIN_TYPE_ARBITRARY] = (_c = {},
                    _c[ARBITRARY_ID_LAST_SENT_MESSAGE] = {
                        value: value,
                        timestamp: Date.now(),
                    },
                    _c),
                _b)));
            dispatch(chatAction.saveMessage(identity, msg));
        }
        catch (error) {
            remoteLog.error(error.message, threadId).then().catch();
        }
    };
    return ChatThreadClass;
}(React.Component));
export { ChatThreadClass };
/**
 * Specific message can force-hide the chat input (e.g. wait widget, or specific widget setting)
 */
var lastMessageHidesInput = function (messages) {
    if (messages === void 0) { messages = []; }
    if (messages.length === 0)
        return false;
    var isPleaseWaitWidget = function (msg) {
        return (msg.type === 'widget' && msg.body === 'PleaseWait') ||
            msg.id === WIDGET_ID_PLEASE_WAIT;
    };
    var isWelcomeWidget = function (msg) {
        return msg.type === 'widget' && msg.body === 'Welcome';
    };
    var isWidgetSettingHideInputBox = function (msg) { var _a, _b, _c; return (_c = (_b = (_a = msg.meta) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.widget) === null || _c === void 0 ? void 0 : _c.hideInputBox; };
    var hideChatInputOn = [
        isPleaseWaitWidget,
        isWelcomeWidget,
        isWidgetSettingHideInputBox
    ];
    var lastMessage = messages[messages.length - 1];
    if (!lastMessage)
        return false;
    if (lastMessage && hideChatInputOn.some(function (fn) { return fn(lastMessage); })) {
        return true;
    }
    return false;
};
var mapStateToProps = function (state, ownProps) {
    var threadId = ownProps.threadId;
    var isOnline = domainSelector.getIsOnlineStatus(state);
    var _messages = domainSelector.getThreadMessages(state)(threadId);
    // remove all network error messages (user is notified via banner when user is offline)
    var hideNetworkErrors = true;
    if (hideNetworkErrors) {
        _messages = _messages.filter(function (m) { return isNetworkErrorMessage(m) === false; });
    }
    if (typeof ChatThreadClass.messageTransformerOrFilter === 'function') {
        _messages = ChatThreadClass.messageTransformerOrFilter(_messages);
    }
    var threadUpdateNotified = 0;
    var n = domainSelector.getClientNotification(state)(NOTIFICATION_ID__THREAD_CHANGE);
    if (n && n.payload.thread_id === threadId && n.created !== void 0) {
        threadUpdateNotified = new Date(n.created).valueOf();
    }
    var lastUpdated = _messages.reduce(function (memo, m) { return Math.max(memo, new Date(m.created).valueOf()); }, 0);
    var threadUpdated = Math.max(lastUpdated, threadUpdateNotified);
    var lastMsg = domainSelector.getLastThreadMessage(state)(threadId);
    var lastMessage = new ChatMessage(__assign({}, lastMsg));
    var isAgent = domainSelector.getOppositeParty(state);
    var uiState = domainSelector.getUIState(state) || {};
    // only consider goodbot/agent messages for getting meta information
    var metaFilterFn = function (message) {
        return message && (message.is_bot || message.is_agent);
    };
    var logMessages = IS_DEVELOPMENT && true;
    if (logMessages) {
        debug('ChatThread: messages', _messages);
        debug('ChatThread: lastMessage', lastMessage);
    }
    var meta = domainSelector.getMeta(state, threadId, metaFilterFn);
    // chat input visibility
    // check isChatInputHidden by meta, meta.named_entities
    var isChatInputHiddenByMeta = ((meta === null || meta === void 0 ? void 0 : meta.named_entities) && meta.named_entities['isChatInputHidden']) ||
        (meta && meta['isChatInputHidden']);
    // make sure possible 'false' string is not interpreted as truly value
    if (typeof isChatInputHiddenByMeta !== 'undefined') {
        isChatInputHiddenByMeta =
            typeof isChatInputHiddenByMeta === 'boolean'
                ? isChatInputHiddenByMeta
                : isChatInputHiddenByMeta === 'true';
    }
    // testing being deprecated - not used
    var isChatInputHiddenByUiState = uiState.chat_input_hidden;
    var isChatInputHiddenByLastMessage = lastMessageHidesInput([lastMessage]);
    var isChatInputHiddenWhenOffline = isOnline === false;
    var isChatInputHidden = [
        isChatInputHiddenByMeta,
        isChatInputHiddenWhenOffline,
        isChatInputHiddenByUiState,
        isChatInputHiddenByLastMessage,
    ].some(Boolean);
    // meta, if set and enables input, overrides all other settings (except offline)
    if (isChatInputHiddenByMeta === false && isOnline) {
        isChatInputHidden = false;
    }
    debug("ChatInputHidden (".concat(isChatInputHidden, "): isOffline: ").concat(isChatInputHiddenWhenOffline, ", meta: ").concat(isChatInputHiddenByMeta, ", uiState: ").concat(isChatInputHiddenByUiState, ", lastMessage: ").concat(isChatInputHiddenByLastMessage));
    return {
        threadId: threadId,
        identity: identitySelector.getIdentity(state),
        threadUpdated: threadUpdated,
        lastMessage: lastMessage,
        messages: _messages,
        isAgent: isAgent,
        chatInputHidden: isChatInputHidden,
        meta: meta,
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return ({
        dispatch: dispatch,
    });
};
export var ChatThread = connect(mapStateToProps, mapDispatchToProps)(ChatThreadClass);
export default ChatThread;
